import { render, staticRenderFns } from "./DataTableTab.vue?vue&type=template&id=714ea3a7&scoped=true&"
import script from "./DataTableTab.vue?vue&type=script&lang=js&"
export * from "./DataTableTab.vue?vue&type=script&lang=js&"
import style0 from "./DataTableTab.vue?vue&type=style&index=0&id=714ea3a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714ea3a7",
  null
  
)

export default component.exports